module.exports = __webpack_public_path__ + "static/img/image@2x (13).2b44b06d.png";